import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function HOOK_GRID2D_CELL__image_select_by_double_click(image: DTO__image_asset) {
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__layout, global__page_type, g_image_edit__tab, g_image_edit__field } = use_slice_ui([
    'g_image_edit__field',
    'global__page_type',
    'g_general__layout',
    'g_image_edit__tab',
  ]);

  async function image_select_by_double_click() {
    if (g_general__layout != ENUM__page_generation_layout.ASSETS) return;
    if (!global__page_type.includes(ENUM__page_type.GENERATION_WITHOUT_PARAMS)) return;
    if (g_image_edit__tab != ENUM__page_generation_layout_images_edit_tab.SELECT) return;
    if (image.is_stub()) return;

    dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__tab', value: ENUM__page_generation_layout_images_edit_tab.VIEW, valid_values: [] }));

    assert_false(g_image_edit__field.is_stub());
    assert_false(image.hash_sha256_content.is_empty_hash_sha256());

    let field_new = g_image_edit__field.clone();
    field_new.image__asset_use(image);

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  return { image_select_by_double_click };
}
